import { getTheme, Icon, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import React from 'react';

interface IPRIVATE_CONTEXT_MENU_BUTTONProps {
  color: string;
  icon: string;
  title: string;
  endButton?: boolean;
  onClick: () => void;
}

const getStyles = (theme: ITheme, buttonColor: string, isEndButton: boolean) => {
  const rightBorderRadius = isEndButton ? 4 : undefined;

  const main: IStyle = {
    all: 'unset',
    width: '5.8em',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: buttonColor,
    color: theme.palette.white,
    opacity: 0.9,
    borderTopRightRadius: rightBorderRadius,
    borderBottomRightRadius: rightBorderRadius,
    cursor: 'pointer',

    '&:focus': {
      outline: `1px dashed ${theme.palette.white}`,
    },
    '&:hover': {
      opacity: 0.75,
    },
    '&:active': {
      opacity: 1,
    }
  };

  const icon: IStyle = {
    fontSize: '2.5em',
  };
  
  return mergeStyleSets({
    main,
    icon,
  });
};

export const PRIVATE_CONTEXT_MENU_BUTTON: React.FunctionComponent<IPRIVATE_CONTEXT_MENU_BUTTONProps> = (props) => {
  const theme = getTheme();
  const styles = getStyles(theme, props.color, props.endButton === true);

  return (
    <button className={styles.main} onClick={() => props.onClick()} title={props.title} aria-label={props.title}>
      <Icon iconName={props.icon} className={styles.icon} />
    </button>
  );
};
